function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Services(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.264 12.084c.864 0 1.602.55 1.88 1.32.775-.42 1.68-.888 2.128-1.027 1.424-.443 6.07.348 7.198 1.232.479.375.752.807.885 1.249 1.001-.741 1.54-1.09 2.011-1.183.845-.17 1.574-.312 2.525.374.816.588 1.182 1.599 1.004 2.773-.237 1.556-3.806 4.172-3.84 4.194-1.597 1.045-4.252 1.669-5.574 1.669-.14 0-.265-.007-.372-.021-1.215-.161-2.518-.517-3.565-.803-.553-.151-1.075-.294-1.327-.331a3.936 3.936 0 00-.525-.025h-.237l-.295.003-.082.002a2.002 2.002 0 01-1.814 1.158H3c-1.103 0-2-.897-2-2v-6.584c0-1.103.897-2 2-2h2.264zm4.605 2.202c-.37.116-1.631.79-2.605 1.34l.002 3.882c.783-.009 1.086.019 1.25.043.367.056.891.199 1.555.38.99.27 2.22.608 3.3.75.607.076 3.186-.421 4.59-1.34.708-.462 2.76-2.312 2.97-2.878.031-.233.032-.617-.21-.792-.23-.168-.246-.175-.965-.035-.226.088-1.128.766-1.666 1.17-.643.483-1.198.9-1.59 1.105-.767.399-1.47.6-2.092.6l-2.209-.21a1 1 0 11.194-1.99l2.112.206c.139-.004.408-.08.725-.217.075-.117.458-.763.007-1.116-.69-.505-4.558-1.15-5.368-.898zm-4.605-.202H3v6.584h2.265l-.001-6.584zM15.507 1a1 1 0 011 1v2.776h2.777a1 1 0 110 2h-2.777v2.777a1 1 0 11-2 0V6.776h-2.775a1 1 0 110-2h2.775V2a1 1 0 011-1z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoServices = /*#__PURE__*/React.memo(Services);
export default MemoServices;